/* ─── Veloz Autohaus Theme JS ───────────────────────────── */
'use strict';

/* ─── Utility ────────────────────────────────────────────── */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const formatMoney = (cents) => {
  return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

/* ─── Header Scroll ──────────────────────────────────────── */
function initHeader() {
  const header = $('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ─── Mobile Menu ────────────────────────────────────────── */
function initMobileMenu() {
  const toggle = $('.mobile-menu-btn');
  const nav    = $('.mobile-nav');
  const icon   = toggle?.querySelector('[data-icon]');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open);
    if (icon) icon.innerHTML = open
      ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>';
  });

  // Sub-menu toggles
  $$('.mobile-nav-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sub = btn.nextElementSibling;
      if (!sub) return;
      sub.classList.toggle('open');
      const chevron = btn.querySelector('.nav-chevron');
      if (chevron) chevron.style.transform = sub.classList.contains('open') ? 'rotate(180deg)' : '';
    });
  });
}

/* ─── Desktop Dropdowns / Mega ───────────────────────────── */
function initNavDropdowns() {
  $$('.nav-item[data-has-dropdown]').forEach(item => {
    let timer;
    item.addEventListener('mouseenter', () => { clearTimeout(timer); item.classList.add('open'); });
    item.addEventListener('mouseleave', () => { timer = setTimeout(() => item.classList.remove('open'), 100); });
    const toggle = item.querySelector('.nav-link');
    toggle?.addEventListener('click', (e) => {
      if (window.innerWidth < 1024) return;
      e.preventDefault();
      item.classList.toggle('open');
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.nav-item')) $$('.nav-item.open').forEach(el => el.classList.remove('open'));
  });
}

/* ─── Cart Drawer ────────────────────────────────────────── */
const cartDrawer = {
  overlay: null,
  drawer: null,

  init() {
    this.overlay = $('.cart-drawer-overlay');
    this.drawer  = $('.cart-drawer');
    if (!this.overlay) return;

    this.overlay.addEventListener('click', () => this.close());
    $$('[data-cart-open]').forEach(btn => btn.addEventListener('click', () => this.open()));
    $$('[data-cart-close]').forEach(btn => btn.addEventListener('click', () => this.close()));

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });

    this.fetchAndRender();
  },

  open() {
    this.overlay.classList.add('open');
    this.drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
    this.fetchAndRender();
  },

  close() {
    this.overlay.classList.remove('open');
    this.drawer.classList.remove('open');
    document.body.style.overflow = '';
  },

  async fetchAndRender() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch(e) { console.error('Cart fetch failed', e); }
  },

  render(cart) {
    const body    = $('.cart-drawer-body');
    const countEl = $$('[data-cart-count]');
    const totalEl = $$('[data-cart-total]');

    countEl.forEach(el => el.textContent = cart.item_count);
    totalEl.forEach(el => el.textContent = formatMoney(cart.total_price));

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-drawer-empty">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
          <p style="font-size:0.9rem;color:var(--color-gray)">Your cart is empty</p>
          <a href="/collections/for-sale" class="btn btn-ghost btn-sm" style="margin-top:0.5rem">Browse Vehicles</a>
        </div>`;
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <div class="cart-item-image">
          <img src="${item.image ? item.image.replace('http:', 'https:') : ''}" alt="${item.product_title}" loading="lazy">
        </div>
        <div style="flex:1;min-width:0">
          <div class="cart-item-title">${item.product_title}</div>
          <div class="cart-item-meta">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <button class="cart-item-remove" data-remove="${item.variant_id}">Remove</button>
        </div>
      </div>`).join('');

    body.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => this.removeItem(btn.dataset.remove));
    });
  },

  async addItem(variantId, quantity = 1, properties = {}) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity, properties }),
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await this.fetchAndRender();
      this.open();
    } catch(e) { console.error(e); alert('Could not add to cart. Please try again.'); }
  },

  async removeItem(variantId) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 }),
      });
      const cart = await res.json();
      this.render(cart);
    } catch(e) { console.error(e); }
  },
};

/* ─── Add to Cart Buttons ────────────────────────────────── */
function initAddToCart() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();
    const variantId = btn.dataset.variantId || btn.dataset.addToCart;
    if (!variantId) return;

    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span style="opacity:0.7">Adding...</span>';

    const properties = {};
    const form = btn.closest('form');
    if (form) {
      form.querySelectorAll('[data-cart-property]').forEach(input => {
        properties[input.dataset.cartProperty] = input.value;
      });
    }

    await cartDrawer.addItem(variantId, 1, properties);

    btn.innerHTML = '✓ Added';
    btn.style.background = 'rgba(34,197,94,0.15)';
    btn.style.borderColor = 'rgba(34,197,94,0.3)';
    btn.style.color = '#4ade80';
    setTimeout(() => {
      btn.innerHTML = original;
      btn.disabled = false;
      btn.style.background = '';
      btn.style.borderColor = '';
      btn.style.color = '';
    }, 2500);
  });
}

/* ─── Buy Now: $2,000 Booking Deposit ───────────────────── */
function initBookDeposit() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-book-deposit]');
    if (!btn) return;
    e.preventDefault();
    const depositVariantId = btn.dataset.depositVariantId;
    if (!depositVariantId) {
      alert('Booking is temporarily unavailable. Please contact us to reserve this vehicle.');
      return;
    }

    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Processing...';

    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: depositVariantId,
          quantity: 1,
          properties: {
            'Vehicle': btn.dataset.vehicleTitle,
            'Vehicle Price': btn.dataset.vehiclePrice,
            'Vehicle Page': window.location.origin + '/products/' + btn.dataset.vehicleHandle,
          },
        }),
      });
      if (!res.ok) throw new Error('Add to cart failed');
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      alert('Could not start your booking. Please try again or contact us.');
      btn.disabled = false;
      btn.innerHTML = original;
    }
  });
}

/* ─── Rent a Car: Date Range Booking ─────────────────────── */
function initBookRental() {
  const btn = $('[data-book-rental]');
  if (!btn) return;

  const fromInput = $('[data-rental-from]');
  const toInput = $('[data-rental-to]');
  const summary = $('[data-rental-summary]');
  const today = new Date().toISOString().split('T')[0];
  if (fromInput) fromInput.min = today;

  function weeks() {
    if (!fromInput?.value || !toInput?.value) return 0;
    const from = new Date(fromInput.value);
    const to = new Date(toInput.value);
    const diffDays = Math.round((to - from) / 86400000);
    return diffDays > 0 ? Math.ceil(diffDays / 7) : 0;
  }

  function updateSummary() {
    if (toInput) toInput.min = fromInput?.value || today;
    if (!summary) return;
    const n = weeks();
    const rate = parseFloat(btn.dataset.dailyRate || 0);
    summary.textContent = (n > 0 && rate > 0)
      ? `${n} week${n > 1 ? 's' : ''} × $${rate}/week = $${(n * rate).toLocaleString('en-AU')} total`
      : '';
  }
  fromInput?.addEventListener('change', updateSummary);
  toInput?.addEventListener('change', updateSummary);

  btn.addEventListener('click', async () => {
    const n = weeks();
    if (n < 1) { alert('Please select a valid "From" and "To" date.'); return; }

    const original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Processing...';

    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: btn.dataset.variantId,
          quantity: n,
          properties: {
            'Rental Start': fromInput.value,
            'Rental End': toInput.value,
            'Weeks': String(n),
          },
        }),
      });
      if (!res.ok) throw new Error('Add to cart failed');
      window.location.href = '/checkout';
    } catch (err) {
      console.error(err);
      alert('Could not start your booking. Please try again or contact us.');
      btn.disabled = false;
      btn.innerHTML = original;
    }
  });
}

/* ─── Product Gallery ────────────────────────────────────── */
function initProductGallery() {
  const mainImg = $('.product-main-image img');
  if (!mainImg) return;
  $$('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img')?.src;
      if (src) { mainImg.src = src; mainImg.setAttribute('srcset', ''); }
      $$('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
}

/* ─── Product Tabs ───────────────────────────────────────── */
function initProductTabs() {
  $$('.product-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      $$('.product-tab').forEach(t => t.classList.remove('active'));
      $$('.product-tab-content').forEach(c => c.classList.remove('active'));
      tab.classList.add('active');
      const content = $(`[data-tab-content="${target}"]`);
      if (content) content.classList.add('active');
    });
  });
}

/* ─── Finance Calculator ─────────────────────────────────── */
function initFinanceCalc() {
  const calc = $('.finance-calc');
  if (!calc) return;
  const priceInput    = calc.querySelector('[data-price]');
  const depositInput  = calc.querySelector('[data-deposit]');
  const rateInput     = calc.querySelector('[data-rate]');
  const termInput     = calc.querySelector('[data-term]');
  const resultEl      = calc.querySelector('[data-monthly]');
  if (!resultEl) return;

  const calculate = () => {
    const price   = parseFloat(priceInput?.value || 0);
    const deposit = parseFloat(depositInput?.value || 10) / 100;
    const rate    = parseFloat(rateInput?.value || 7.99) / 100 / 12;
    const term    = parseInt(termInput?.value || 60);
    const principal = price * (1 - deposit);
    if (!principal || !rate) return;
    const monthly = (principal * rate * Math.pow(1 + rate, term)) / (Math.pow(1 + rate, term) - 1);
    resultEl.textContent = '$' + Math.round(monthly).toLocaleString('en-AU') + '/mo';
  };

  [priceInput, depositInput, rateInput, termInput].forEach(el => {
    el?.addEventListener('input', calculate);
  });
  calculate();
}

/* ─── Vehicle Filters (Collection Page) ─────────────────── */
function initVehicleFilters() {
  const filterForm = $('.vehicle-filter-form');
  if (!filterForm) return;

  // Auto-submit on change for select/checkbox inputs
  filterForm.querySelectorAll('select, input[type="checkbox"]').forEach(el => {
    el.addEventListener('change', () => filterForm.submit());
  });

  // Price range display
  const priceMin = filterForm.querySelector('[data-price-min]');
  const priceMax = filterForm.querySelector('[data-price-max]');
  const priceDisplay = filterForm.querySelector('[data-price-display]');
  const updatePriceDisplay = () => {
    if (!priceDisplay) return;
    const min = parseInt(priceMin?.value || 0);
    const max = parseInt(priceMax?.value || 999999);
    priceDisplay.textContent = `$${(min/1000).toFixed(0)}k – $${(max/1000).toFixed(0)}k`;
  };
  priceMin?.addEventListener('input', updatePriceDisplay);
  priceMax?.addEventListener('input', updatePriceDisplay);
  updatePriceDisplay();

  // Mobile filter panel toggle
  const mobileToggle = $('.filter-mobile-toggle');
  const filtersPanel = $('.filters-panel');
  mobileToggle?.addEventListener('click', () => {
    if (window.innerWidth >= 1024) return;
    const hidden = filtersPanel.style.display === 'none' || !filtersPanel.style.display;
    filtersPanel.style.display = hidden ? 'block' : 'none';
  });
  if (filtersPanel && window.innerWidth < 1024) filtersPanel.style.display = 'none';
}

/* ─── Trade-In Form ──────────────────────────────────────── */
function initTradeInForm() {
  const form = $('.trade-in-form');
  if (!form) return;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const data = new FormData(form);
    btn.disabled = true;
    btn.textContent = 'Submitting...';
    // In production, POST to a Shopify contact form or custom endpoint
    await new Promise(r => setTimeout(r, 1000));
    form.innerHTML = `<div class="alert alert-success" style="justify-content:center;text-align:center;padding:2rem">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
      <div><strong>Trade-in request submitted!</strong><br><span style="font-size:0.8rem;opacity:0.8">We'll contact you within 24 hours with a valuation.</span></div>
    </div>`;
  });
}

/* ─── Contact Form ───────────────────────────────────────── */
function initContactForm() {
  const form = $('.contact-form');
  if (!form) return;
  // Shopify contact form handles submission natively; just enhance UX
  form.addEventListener('submit', (e) => {
    const btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
  });
}

/* ─── Smooth Reveal on Scroll ────────────────────────────── */
function initScrollReveal() {
  if (!window.IntersectionObserver) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

  $$('[data-reveal]').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });
}

/* ─── Init ───────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initMobileMenu();
  initNavDropdowns();
  cartDrawer.init();
  initAddToCart();
  initBookDeposit();
  initBookRental();
  initProductGallery();
  initProductTabs();
  initFinanceCalc();
  initVehicleFilters();
  initTradeInForm();
  initContactForm();
  initScrollReveal();
});
